import {SocialMedia} from '../interfaces/social-media.interface';

export class SocialMediaHelper {
  public static init(twitter = '', linkedin = '', facebook = '', skype = '', instagram = ''): SocialMedia {
    return {twitter, linkedin, facebook, skype, instagram};
  }
}
